import {
  AscendingSort,
  AscendingSortNumbersArray
} from './sortNumbers.types'

const ascendingSort: AscendingSort = (a, b) => (
  a - b
)

export const ascendingSortNumbersArray: AscendingSortNumbersArray = array => array.sort(ascendingSort)
